import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-word_yuan",
  "use": "icon-word_yuan-usage",
  "viewBox": "0 0 38 53",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 38 53\" id=\"icon-word_yuan\">\n<path fill-rule=\"evenodd\" d=\"M1.640,0.013 C1.640,0.013 28.546,0.013 28.543,0.013 C28.513,0.013 29.129,3.458 31.451,5.755 C33.868,8.144 37.995,9.389 37.995,9.343 C37.995,9.322 37.823,51.567 37.823,51.567 C37.823,52.360 37.172,53.002 36.369,53.002 L1.468,53.002 C0.664,53.002 0.014,52.360 0.014,51.567 L0.186,1.448 C0.186,0.655 0.837,0.013 1.640,0.013 Z\" />\n<path fill-rule=\"evenodd\" fill=\"rgb(207, 223, 242)\" d=\"M28.543,0.013 L28.543,9.343 L37.995,9.343 L28.543,0.013 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/word_yuan.svg
// module id = HKFM
// module chunks = 70